import { fetchRobot } from '../../utils/robot';
import { pythonInvokeRequest } from '../types';

export async function pythonInvokeHandler(request: pythonInvokeRequest) {
  return await fetchRobot('api/llm/invoke', 'POST', request);
}
